
import store from '@/store/index'
// 获取当前年月日
function getNDate() {
  const now = new Date()
  const year = now.getFullYear()
  const month = now.getMonth() + 1 // 月份从0开始，需要加1
  const day = now.getDate()
  const data = `${year}${month}${day}`
  return data
}

// 读取缓存文件时间
function readCacheDate() {
  if (store.state.klinecache.cacheDate) {
    return JSON.parse(JSON.stringify(store.state.klinecache.cacheDate))
  } else {
    writeCacheDate()
    return null
  }
}

// 写入缓存时间
function writeCacheDate() {
  const data = getNDate()
  store.commit('setCacheDate', data)
}

// 比较缓存日期是否过期(当日)
function isDateExpired() {
  const currentDate = getNDate() // 当前日期
  const dateStr = readCacheDate() // 缓存日期
  if (!dateStr) {
    // 没有缓存,认为已过期
    return true
  }
  return currentDate !== dateStr
}

// 读取缓存文件
function readCacheFile() {
  if (isDateExpired()) {
    // console.log('缓存已过期')
    return {
      kline_1m: {
        /* eg: 
          kline+商品id : klineData k线数据,
          kline256 代表商品id为256的商品
           ... 
        */
      },
      kline_3m: {},
      kline_5m: {},
      kline_10m: {},
      kline_15m: {},
      kline_30m: {},
      kline_60m: {},
      kline_2h: {},
      kline_4h: {},
      kline_1d: {},
      kline_1w: {},
      kline_month: {}
    }
  }
  // console.log('查找缓存信息', store.state.klinecache.klines)
  if (store.state.klinecache.klines) {
    // console.log('查找缓存信息', store.state.klinecache.klines)
    return JSON.parse(JSON.stringify(store.state.klinecache.klines))
  } else {
    return {
      kline_1m: {
        /* eg: 
          kline+商品id : klineData k线数据,
          kline256 代表商品id为256的商品
           ... 
        */
      },
      kline_3m: {},
      kline_5m: {},
      kline_10m: {},
      kline_15m: {},
      kline_30m: {},
      kline_60m: {},
      kline_2h: {},
      kline_4h: {},
      kline_1d: {},
      kline_1w: {},
      kline_month: {}
    }
  }
}

// 写入缓存文件
function writeCacheFile(data) {
  // console.log('写入缓存文件 原', data)
  if (data) {
    store.commit('setKlineCache', JSON.parse(JSON.stringify(data)))
    // 写入缓存后更新缓存时间
    writeCacheDate()
  }
}

function periodToFilename(period) {
  let fileName = ''
  switch (period) {
    case 0:
      fileName = 'kline_1m'
      break
    case 1:
      fileName = 'kline_5m'
      break
    case 2:
      fileName = 'kline_15m'
      break
    case 3:
      fileName = 'kline_30m'
      break
    case 4:
      fileName = 'kline_60m'
      break
    case 5:
      fileName = 'kline_1d'
      break
    case 6:
      fileName = 'kline_1w'
      break
    case 7:
      fileName = 'kline_month'
      break
    case 9:
      fileName = 'kline_4h'
      break
    case 10:
      fileName = 'kline_3m'
      break
    case 11:
      fileName = 'kline_10m'
      break
    case 12:
      fileName = 'kline_2h'
      break
    default:
      break
  }
  return fileName
}

function getSymbol(symbol) {
  const newStr = symbol.substring(0, symbol.indexOf('_'))
  return newStr
}

// 读取分钟k线历史数据
/*
  symbol: 商品id

  period : k线精度
  0: 1m
  1: 5m
  2: 15m
  3: 30m
  4: 60m
  5: 天
  6: 周
  7: 月
  9: 4h
  10: 3m
  11: 10m
  12: 2h
*/
function readCacheFileKLine(symbol, period) {
  const fileName = periodToFilename(period)
  const klines = readCacheFile()
  try {
    const cacheData = klines[fileName]
    /*
    cacheData -
              {
                kline+商品id : klineData k线数据,
                kline256 代表商品id为256的商品
                ...
              }
     */
    let kline = null
    const symboln = getSymbol(symbol)
    if (cacheData) {
      kline = cacheData['kline' + symboln]
    }
    console.log('读取缓存'+symboln+' '+period, kline)
    return kline || null
  } catch (error) {
    // console.log(error)
    return null
  }
}
// 写入分钟k线历史数据
function writeCacheFileKLine(symbol, period, data) {
  console.log('h1h写入缓存'+symbol+' '+period, data)
  const symboln = getSymbol(symbol)
  const fileName = periodToFilename(period)
  // 查询缓存数据
  const key = 'kline' + symboln

  const klines = readCacheFile()

  // 添加新数据
  klines[fileName][key] = data

  console.log('hh写入缓存'+symboln+' '+period, data, klines)
  // 写入缓存
  writeCacheFile(klines)
}

// 更新分钟k线缓存数据
function upDateCacheFileKLine(symbol, period, data) {
  console.log('h2h写入缓存'+symbol+' '+period, data)
  const symboln = getSymbol(symbol)
  const fileName = periodToFilename(period)

  // 查询缓存数据
  const key = 'kline' + symboln
  const klines = readCacheFile()

  // 读取缓存
  let klineData = readCacheFileKLine(symbol, period)
  console.log('h2h写入缓存'+symbol+' '+period, '读取当前存储信息', klineData)

  // 合并新旧数据并排序
  function mergeKlineData(historyData, updateData) {
    // 创建以时间戳为key的映射，便于快速查找和更新
    const dataMap = new Map();
    
    // 先添加历史数据
    historyData && historyData.forEach(item => {
      dataMap.set(item[0], item);
    });
    
    // 用更新数据覆盖或添加
    updateData.forEach(item => {
      dataMap.set(item[0], item);
    });
    
    // 转换为数组并按时间戳排序
    const mergedData = Array.from(dataMap.values());
    mergedData.sort((a, b) => a[0] - b[0]);
    
    return mergedData;
  }

  if (klineData) {
    // 存储变动信息
    let newDataArr = data.data
    let oldDataArr = klineData.data

    klines[fileName][key].data = mergeKlineData(oldDataArr, newDataArr)
  } else {
    // 添加新数据
    klines[fileName][key] = data
  }
  
  // console.log('hh写入缓存'+symboln+' '+period, data, klines)
  // 写入缓存
  writeCacheFile(klines)
}

export default {
  readCacheFileKLine,
  writeCacheFileKLine,
  upDateCacheFileKLine
}
